import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#3d2817] text-[#f6efe0] mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-10 rounded-full bg-[#c9a15b] text-[#3d2817] grid place-items-center font-serif text-xl">❉</span>
            <span>
              <span className="block font-serif text-lg">Van Hanh Monastery</span>
              <span className="block text-[10px] tracking-[0.25em] uppercase text-[#c9a15b]">Canberra</span>
            </span>
          </div>
          <p className="text-sm text-[#e6d9be]/80 leading-relaxed">
            A place of peace, learning and community. Established 1983 in Lyneham, ACT — serving all who seek refuge, kindness and belonging.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4 text-[#f6efe0]">Visit</h4>
          <ul className="space-y-3 text-sm text-[#e6d9be]/90">
            <li className="flex gap-3"><MapPin size={16} className="mt-1 flex-shrink-0 text-[#c9a15b]" /><span>32 Archibald Street<br />Lyneham, ACT 2602<br />Australia</span></li>
            <li className="flex gap-3"><Phone size={16} className="mt-1 flex-shrink-0 text-[#c9a15b]" /><a href="tel:+61262575280" className="hover:text-[#c9a15b]">(02) 6257 5280</a></li>
            <li className="flex gap-3"><Mail size={16} className="mt-1 flex-shrink-0 text-[#c9a15b]" /><a href="mailto:info@vanhanhcanberra.com" className="hover:text-[#c9a15b] break-all">info@vanhanhcanberra.com</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4 text-[#f6efe0]">Explore</h4>
          <ul className="space-y-2 text-sm text-[#e6d9be]/90">
            <li><Link to="/about" className="hover:text-[#c9a15b]">Our Story</Link></li>
            <li><Link to="/programs" className="hover:text-[#c9a15b]">Programs & Services</Link></li>
            <li><Link to="/community" className="hover:text-[#c9a15b]">Community Outreach</Link></li>
            <li><Link to="/visit" className="hover:text-[#c9a15b]">Plan a Visit</Link></li>
            <li><Link to="/support" className="hover:text-[#c9a15b]">Ways to Give</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4 text-[#f6efe0]">Weekly Practice</h4>
          <ul className="space-y-2 text-sm text-[#e6d9be]/90">
            <li><span className="text-[#c9a15b]">Thu</span> · Meditation 7:30pm</li>
            <li><span className="text-[#c9a15b]">Sun</span> · Meditation 6:30pm</li>
            <li><span className="text-[#c9a15b]">Sun</span> · Dharma Talk 10:00am</li>
            <li className="pt-2 text-xs text-[#e6d9be]/70">All are welcome. No prior experience required.</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#5a3d24]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#e6d9be]/70">
          <p>© {new Date().getFullYear()} The United Vietnamese Buddhist Congregation of Canberra and Surrounds. ABN 20 648 948 015. Registered Charity.</p>
          <p><a href="https://www.acnc.gov.au/charity/charities/6b67e52c-38af-e811-a95e-000d3ad24c60/profile" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a15b]">ACNC Charity Profile</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
